module.exports = __webpack_public_path__ + "img/2.30e9ca25.jpg";